import { lazy } from 'react';
import ProtectedRoute from '../components/auth/ProtectedRoute';

// Lazy load HR components for better performance
const EmployeePage = lazy(() => import('../pages/hr/Employees'));
const EmployeeDetail = lazy(() => import('../pages/hr/EmployeeDetail'));
const EmployeeForm = lazy(() => import('../pages/hr/EmployeeForm'));

const LeavePage = lazy(() => import('../pages/hr/Leave'));
// const LeaveDetail = lazy(() => import('../pages/hr/LeaveDetail'));
// const LeaveForm = lazy(() => import('../pages/hr/LeaveForm'));
// const LeaveCalendar = lazy(() => import('../pages/hr/LeaveCalendar'));

const AttendancePage = lazy(() => import('../pages/hr/Attendance'));
// const AttendanceDetail = lazy(() => import('../pages/hr/AttendanceDetail'));
// const AttendanceReports = lazy(() => import('../pages/hr/AttendanceReports'));
const MyAttendance = lazy(() => import('../pages/hr/MyAttendance'));

const PerformancePage = lazy(() => import('../pages/hr/Performance'));
// const PerformanceDetail = lazy(() => import('../pages/hr/PerformanceDetail'));
// const PerformanceForm = lazy(() => import('../pages/hr/PerformanceForm'));
const GoalsPage = lazy(() => import('../pages/hr/Goals'));
// const GoalDetail = lazy(() => import('../pages/hr/GoalDetail'));
// const GoalForm = lazy(() => import('../pages/hr/GoalForm'));

const RecruitmentPage = lazy(() => import('../pages/hr/Recruitment'));
// const JobPostingDetail = lazy(() => import('../pages/hr/JobPostingDetail'));
// const JobPostingForm = lazy(() => import('../pages/hr/JobPostingForm'));
// const CandidatesPage = lazy(() => import('../pages/hr/Candidates'));
// const CandidateDetail = lazy(() => import('../pages/hr/CandidateDetail'));
// const ApplicationDetail = lazy(() => import('../pages/hr/ApplicationDetail'));

const OrgChartPage = lazy(() => import('../pages/hr/OrgChart'));

const HRDashboard = lazy(() => import('../pages/hr/HRDashboard'));

// HR route configuration
const hrRoutes = [
  {
    path: 'hr',
    children: [
      {
        index: true,
        element: (
          <ProtectedRoute 
            requiredPermission={{ resource: 'employees', action: 'read' }}
          >
            <HRDashboard />
          </ProtectedRoute>
        )
      },
      
      // Employee Management Routes
      {
        path: 'employees',
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute 
                requiredPermission={{ resource: 'employees', action: 'read' }}
              >
                <EmployeePage />
              </ProtectedRoute>
            )
          },
          {
            path: 'new',
            element: (
              <ProtectedRoute 
                requiredPermission={{ resource: 'employees', action: 'create' }}
              >
                <EmployeeForm />
              </ProtectedRoute>
            )
          },
          {
            path: ':id',
            element: (
              <ProtectedRoute 
                requiredPermission={{ resource: 'employees', action: 'read' }}
              >
                <EmployeeDetail />
              </ProtectedRoute>
            )
          },
          {
            path: ':id/edit',
            element: (
              <ProtectedRoute 
                requiredPermission={{ resource: 'employees', action: 'update' }}
              >
                <EmployeeForm />
              </ProtectedRoute>
            )
          }
        ]
      },
      
      // Leave Management Routes
      {
        path: 'leave',
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute 
                requiredPermission={{ resource: 'leaves', action: 'read' }}
              >
                <LeavePage />
              </ProtectedRoute>
            )
          },
          // {
          //   path: 'calendar',
          //   element: (
          //     <ProtectedRoute 
          //       element={<LeaveCalendar />} 
          //       requiredPermissions={[{ resource: 'leaves', action: 'read', scope: 'team' }]}
          //     />
          //   )
          // },
          // {
          //   path: 'new',
          //   element: (
          //     <ProtectedRoute 
          //       element={<LeaveForm />} 
          //       requiredPermissions={[{ resource: 'leaves', action: 'create', scope: 'own' }]}
          //     />
          //   )
          // },
          // {
          //   path: ':id',
          //   element: (
          //     <ProtectedRoute 
          //       element={<LeaveDetail />} 
          //       requiredPermissions={[{ resource: 'leaves', action: 'read', scope: 'team' }]}
          //     />
          //   )
          // },
          // {
          //   path: ':id/edit',
          //   element: (
          //     <ProtectedRoute 
          //       element={<LeaveForm />} 
          //       requiredPermissions={[{ resource: 'leaves', action: 'update', scope: 'own' }]}
          //     />
          //   )
          // }
        ]
      },
      
      // Attendance Management Routes
      {
        path: 'attendance',
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute 
                requiredPermission={{ resource: 'attendance', action: 'read' }}
              >
                <AttendancePage />
              </ProtectedRoute>
            )
          },
          {
            path: 'my',
            element: (
              <ProtectedRoute 
                requiredPermission={{ resource: 'attendance', action: 'read' }}
              >
                <MyAttendance />
              </ProtectedRoute>
            )
          },
          // {
          //   path: 'reports',
          //   element: (
          //     <ProtectedRoute 
          //       element={<AttendanceReports />} 
          //       requiredPermissions={[{ resource: 'attendance', action: 'reports', scope: 'team' }]}
          //     />
          //   )
          // },
          // {
          //   path: ':id',
          //   element: (
          //     <ProtectedRoute 
          //       element={<AttendanceDetail />} 
          //       requiredPermissions={[{ resource: 'attendance', action: 'read', scope: 'team' }]}
          //     />
          //   )
          // }
        ]
      },
      
      // Performance Management Routes
      {
        path: 'performance',
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute 
                requiredPermission={{ resource: 'performance', action: 'read' }}
              >
                <PerformancePage />
              </ProtectedRoute>
            )
          },
          // {
          //   path: 'new',
          //   element: (
          //     <ProtectedRoute 
          //       element={<PerformanceForm />} 
          //       requiredPermissions={[{ resource: 'performance', action: 'create', scope: 'team' }]}
          //     />
          //   )
          // },
          // {
          //   path: ':id',
          //   element: (
          //     <ProtectedRoute 
          //       element={<PerformanceDetail />} 
          //       requiredPermissions={[{ resource: 'performance', action: 'read', scope: 'team' }]}
          //     />
          //   )
          // },
          // {
          //   path: ':id/edit',
          //   element: (
          //     <ProtectedRoute 
          //       element={<PerformanceForm />} 
          //       requiredPermissions={[{ resource: 'performance', action: 'update', scope: 'team' }]}
          //     />
          //   )
          // }
        ]
      },
      
      // Goals Management Routes
      {
        path: 'goals',
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute 
                requiredPermission={{ resource: 'goals', action: 'read' }}
              >
                <GoalsPage />
              </ProtectedRoute>
            )
          },
          // {
          //   path: 'new',
          //   element: (
          //     <ProtectedRoute 
          //       element={<GoalForm />} 
          //       requiredPermissions={[{ resource: 'goals', action: 'create', scope: 'team' }]}
          //     />
          //   )
          // },
          // {
          //   path: ':id',
          //   element: (
          //     <ProtectedRoute 
          //       element={<GoalDetail />} 
          //       requiredPermissions={[{ resource: 'goals', action: 'read', scope: 'team' }]}
          //     />
          //   )
          // },
          // {
          //   path: ':id/edit',
          //   element: (
          //     <ProtectedRoute 
          //       element={<GoalForm />} 
          //       requiredPermissions={[{ resource: 'goals', action: 'update', scope: 'team' }]}
          //     />
          //   )
          // }
        ]
      },
      
      // Recruitment Management Routes
      {
        path: 'recruitment',
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute 
                requiredPermission={{ resource: 'recruitment', action: 'read' }}
              >
                <RecruitmentPage />
              </ProtectedRoute>
            )
          },
          // {
          //   path: 'jobs',
          //   children: [
          //     {
          //       path: 'new',
          //       element: (
          //         <ProtectedRoute 
          //           element={<JobPostingForm />} 
          //           requiredPermissions={[{ resource: 'recruitment', action: 'create', scope: 'organization' }]}
          //         />
          //       )
          //     },
          //     {
          //       path: ':id',
          //       element: (
          //         <ProtectedRoute 
          //           element={<JobPostingDetail />} 
          //           requiredPermissions={[{ resource: 'recruitment', action: 'read', scope: 'organization' }]}
          //         />
          //       )
          //     },
          //     {
          //       path: ':id/edit',
          //       element: (
          //         <ProtectedRoute 
          //           element={<JobPostingForm />} 
          //           requiredPermissions={[{ resource: 'recruitment', action: 'update', scope: 'organization' }]}
          //         />
          //       )
          //     }
          //   ]
          // },
          // {
          //   path: 'candidates',
          //   children: [
          //     {
          //       index: true,
          //       element: (
          //         <ProtectedRoute 
          //           element={<CandidatesPage />} 
          //           requiredPermissions={[{ resource: 'recruitment', action: 'read', scope: 'organization' }]}
          //         />
          //       )
          //     },
          //     {
          //       path: ':id',
          //       element: (
          //         <ProtectedRoute 
          //           element={<CandidateDetail />} 
          //           requiredPermissions={[{ resource: 'recruitment', action: 'read', scope: 'organization' }]}
          //         />
          //       )
          //     }
          //   ]
          // },
          // {
          //   path: 'applications/:candidateId/:jobId',
          //   element: (
          //     <ProtectedRoute 
          //       element={<ApplicationDetail />} 
          //       requiredPermissions={[{ resource: 'recruitment', action: 'read', scope: 'organization' }]}
          //     />
          //   )
          // }
        ]
      },
      
      // Organization Chart Routes
      {
        path: 'organization',
        element: (
          <ProtectedRoute 
            requiredPermission={{ resource: 'organization', action: 'read' }}
          >
            <OrgChartPage />
          </ProtectedRoute>
        )
      },
      
      // My Attendance Route (direct path)
      {
        path: 'my-attendance',
        element: (
          <ProtectedRoute 
            requiredPermission={{ resource: 'attendance', action: 'read' }}
          >
            <MyAttendance />
          </ProtectedRoute>
        )
      }
    ]
  }
];

export default hrRoutes;